<template>
  <div class="custom-title-bar" :class="{ 'is-fixed': fixed }" :style="{
    backgroundColor: backgroundColor,
    color: titleColor,
    borderBottom: showBorder ? '1px solid #eee' : 'none'
  }">
    <!-- 左侧返回区域 -->
    <div class="left-area" @click="handleBack" v-if="showBack">
      <slot name="left">
        <SvgIcon name="back" class="back-icon" :color="iconColor" size="18" />
      </slot>
    </div>

    <!-- 标题区域 -->
    <div class="title" :style="{ color: titleColor }">
      <slot>{{ title }}</slot>
    </div>

    <!-- 右侧区域 -->
    <div class="right-area" :style="{ color: rightTextColor }" @click="handleRightClick">
      <slot name="right">
        {{ rightText }}
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  // 标题文本
  title: {
    type: String,
    default: ''
  },
  // 右侧文本
  rightText: {
    type: String,
    default: ''
  },
  // 背景颜色
  backgroundColor: {
    type: String,
    default: '#fff'
  },
  // 标题颜色
  titleColor: {
    type: String,
    default: '#111'
  },
  // 右侧文本颜色
  rightTextColor: {
    type: String,
    default: '#333'
  },
  // 图标颜色
  iconColor: {
    type: String,
    default: '#333'
  },
  // 是否固定在顶部
  fixed: {
    type: Boolean,
    default: true
  },
  // 是否显示底部边框
  showBorder: {
    type: Boolean,
    default: true
  },
  // 是否显示返回按钮
  showBack: {
    type: Boolean,
    default: true
  },
  // 自定义返回逻辑
  customBack: {
    type: Function,
    default: null
  },
  // z-index层级
  zIndex: {
    type: Number,
    default: 100
  }
});

const emit = defineEmits(['rightClick']);

// 返回按钮处理
const handleBack = () => {
  if (props.customBack) {
    props.customBack();
  } else {
    history.back();
  }
};

// 右侧点击处理
const handleRightClick = () => {
  emit('rightClick');
};
</script>

<style lang="scss" scoped>
.custom-title-bar {
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;

  &.is-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: v-bind('props.zIndex');
  }

  .left-area {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 16px;
    cursor: pointer;

    .back-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 16px;
  }

  .right-area {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 16px;
    cursor: pointer;
    font-size: 16px;
  }
}

// 适配iPhone安全区
@supports (padding-top: constant(safe-area-inset-top)) {
  .custom-title-bar.is-fixed {
    padding-top: constant(safe-area-inset-top);
    height: calc(44px + constant(safe-area-inset-top));
  }
}

@supports (padding-top: env(safe-area-inset-top)) {
  .custom-title-bar.is-fixed {
    padding-top: env(safe-area-inset-top);
    height: calc(44px + env(safe-area-inset-top));
  }
}
</style>